module.exports = __webpack_public_path__ + "img/partner4.274229ad.png";